// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1VLqq","buttons":"PendingPaymentAlert_buttons__2SOJE"};